import { photoPosition, photoSide } from '@/types/uiPhoto.types'

export default function () {
  const { t } = useI18n()
  
  const uiPhotoData = () => {
    return {
      desktopPhotoPosition: photoPosition.LEFT,
      photoDesktop: [{
        url: '/images/wellbeing-sale/forWorkers/frame.png',
        public_id: '',
      }],
      photoMobile: [{
        url: '/images/wellbeing-sale/forWorkers/frame.png',
        public_id: '',
      }],
      photoSide: photoSide.LEFT,
      descriptionSize: 'big',
      description: {
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                value: t('wellbeingSale.assistant.paragraph1'),
              },
            ],
          },
          {
            nodeType: 'unordered-list',
            content: [
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forWorkers.bullet1'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forWorkers.bullet2'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forWorkers.bullet3'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forWorkers.bullet4'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forWorkers.bullet5'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forWorkers.bullet6'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forWorkers.bullet7'),
                      },
                    ],
                  },
                ],
              },

            ],
          },
        ],
      },
    }
  }

  return {
    uiPhotoData,
  }
}
